import { useContext, useDebugValue } from 'react'

import { AuthContext } from '@/context/AuthContext'

/**
 * use auth context as hook
 */
const useAuth = () => {
  const { userData } = useContext(AuthContext)
  useDebugValue(userData, (userData) => (userData !== null ? 'Logged In' : 'Logged Out'))
  return useContext(AuthContext)
}

export default useAuth
